<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_663_5793)">
      <path
        d="M1.34948 13.6665C0.966146 13.6665 0.649479 13.5415 0.391146 13.2832C0.132812 13.0249 0.0078125 12.7082 0.0078125 12.3249V4.18319C0.0078125 3.79985 0.132812 3.48319 0.391146 3.22485C0.649479 2.96652 0.966146 2.84152 1.34948 2.84152H4.99948V1.69152C4.99948 1.30819 5.12448 0.99152 5.38281 0.733187C5.64115 0.474854 5.95781 0.349854 6.34115 0.349854H8.64948C9.03281 0.349854 9.34948 0.474854 9.60781 0.733187C9.86615 0.99152 9.99115 1.30819 9.99115 1.69152V2.84152H13.6411C14.0245 2.84152 14.3411 2.96652 14.5995 3.22485C14.8578 3.48319 14.9828 3.79985 14.9828 4.18319V12.3249C14.9828 12.7082 14.8578 13.0249 14.5995 13.2832C14.3411 13.5415 14.0245 13.6665 13.6411 13.6665H1.33281H1.34948ZM5.83281 2.83319H9.16615V1.68319C9.16615 1.55819 9.11615 1.44152 9.00781 1.33319C8.89948 1.22485 8.78281 1.17485 8.65781 1.17485H6.34948C6.22448 1.17485 6.10781 1.22485 5.99948 1.33319C5.89115 1.44152 5.84115 1.55819 5.84115 1.68319V2.83319H5.83281ZM14.1661 9.08319H9.16615V10.3332H5.83281V9.08319H0.832812V12.3165C0.832812 12.4415 0.882813 12.5582 0.991146 12.6665C1.09948 12.7749 1.21615 12.8249 1.34115 12.8249H13.6495C13.7745 12.8249 13.8911 12.7749 13.9995 12.6665C14.1078 12.5582 14.1578 12.4415 14.1578 12.3165V9.08319H14.1661ZM6.66615 9.49985H8.33281V7.83319H6.66615V9.49985ZM0.832812 8.24985H5.83281V6.99985H9.16615V8.24985H14.1661V4.18319C14.1661 4.05819 14.1161 3.94152 14.0078 3.83319C13.8995 3.72485 13.7828 3.67485 13.6578 3.67485H1.34948C1.22448 3.67485 1.10781 3.72485 0.999479 3.83319C0.891146 3.94152 0.841146 4.05819 0.841146 4.18319V8.24985H0.832812Z"
        fill="#1E264C"
      />
    </g>
    <defs>
      <clipPath id="clip0_663_5793">
        <rect
          width="15"
          height="13.3333"
          fill="white"
          transform="translate(0 0.333252)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
